import { render, staticRenderFns } from "./ExerciseSwapMain.vue?vue&type=template&id=530b90bd"
import script from "./ExerciseSwapMain.vue?vue&type=script&lang=js"
export * from "./ExerciseSwapMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports